import { render, staticRenderFns } from "./CorrigirErrosInesperados.vue?vue&type=template&id=bb070fec&scoped=true"
import script from "./CorrigirErrosInesperados.vue?vue&type=script&lang=js"
export * from "./CorrigirErrosInesperados.vue?vue&type=script&lang=js"
import style0 from "./CorrigirErrosInesperados.vue?vue&type=style&index=0&id=bb070fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb070fec",
  null
  
)

export default component.exports